import produce from "immer";
import Config from "../model"; // eslint-disable-next-line no-mixed-requires

var deepmerge = require("deepmerge");

var defaults = require("../defaults.json");

var initialState = {};
/* eslint-disable no-unused-vars, prefer-reflect */

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return produce(state, function (draft) {
    if (Object.getOwnPropertyNames(state).length > 0) {
      return state;
    }

    var configArray = getConfigData();
    var obj = new Config(configArray);
    return obj;
  });
});
export function getConfigData() {
  var configArray = defaults;

  if (window.overrides_data) {
    configArray = deepmerge(configArray, window.overrides_data);
  }

  return configArray;
}